import { NgModule } from '@angular/core';
import { PageNotFound404Component } from './page-not-found-404.component';

export { PageNotFound404Component } from './page-not-found-404.component';

export const MODULE_IMPORTS_AND_EXPORTS = [PageNotFound404Component];

@NgModule({
  imports: MODULE_IMPORTS_AND_EXPORTS,
  exports: MODULE_IMPORTS_AND_EXPORTS,
})
export class GalaxyPageNotFound404Module {}
